export enum SupportedLanguagesEnum {
  EN = 'en',
  DE = 'de'
}
